<template>
  <van-form
    ref="basisForm"
    class="basis-form"
    @submit="success"
  >
    <template v-for="config in keysMap">
      <slot
        :name="`${config.key}-wrapper`"
        :columns="target"
        :config="config"
      >
        <van-field
          :key="config.key"
          v-model="target[config.key]"
          :name="config.rulesName"
          :rules="config.rules"
          :label="config.label"
          :maxlength="config.maxlength"
          :type="config.type"
          :required="config.required"
          :placeholder="config.placeholder"
          :readonly="config.readonly"
        >
          <template v-slot:input>
            <slot :name="`${config.key}-input`" :column="target[config.key]" />
          </template>
          <template v-slot:button>
            <div class="field-wrapper">
              <slot :name="`${config.key}-button`" :column="target[config.key]" />
            </div>
          </template>
        </van-field>
      </slot>
    </template>
    <div class="operate-button-wrapper">
      <slot name="button" />
    </div>
  </van-form>
</template>

<script>
export default {
  name: 'BasisForm',
  props: {
    formRef: {
      type: Object,
      default: () => {}
    },
    keysMap: {
      type: Array,
      required: true
    },
    target: {
      type: Object,
      required: true
    }
  },
  mounted () {
    this.$emit('update:formRef', this.$refs['basisForm'])
  },
  methods: {
    success () {
      console.log('校验通过')
      this.$emit('success')
    }
  }
}
</script>

<style lang="scss">
.basis-form {
  // 把底部按钮的高度留出
  padding-bottom: 23px;
  ::v-deep {
    .van-cell:not(:last-child)::after {
      left: 0;
    }
  }
  .van-field {
    font-size: $font-size-lg;
    padding: 12px 0;
    & + .van-field {
      margin-top: 11px;
    }
  }
  .operate-button-wrapper {
  }
}
</style>
